import { render, staticRenderFns } from "./AppInfoTextPanel.vue?vue&type=template&id=99ebeb98&scoped=true&"
import script from "./AppInfoTextPanel.vue?vue&type=script&lang=js&"
export * from "./AppInfoTextPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoTextPanel.vue?vue&type=style&index=0&id=99ebeb98&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ebeb98",
  null
  
)

export default component.exports